import { ASTONDEVS_STORAGE_URL } from 'constants/api';

export const RECOMMENDATION_LETTERS_PAGES_NAMES = {
  fsc: 'fsc',
  inline_group: 'inline_group',
  omk: 'omk',
  tit: 'tit',
  x5: 'x5',
};

const createPath = fileName => `${ASTONDEVS_STORAGE_URL}recommendationLetters/${fileName}.pdf`;
export const recommendationLettersUrlsSelector = {
  [RECOMMENDATION_LETTERS_PAGES_NAMES.fsc]: createPath(RECOMMENDATION_LETTERS_PAGES_NAMES.fsc),
  [RECOMMENDATION_LETTERS_PAGES_NAMES.inline_group]: createPath(
    RECOMMENDATION_LETTERS_PAGES_NAMES.inline_group,
  ),
  [RECOMMENDATION_LETTERS_PAGES_NAMES.omk]: createPath(RECOMMENDATION_LETTERS_PAGES_NAMES.omk),
  [RECOMMENDATION_LETTERS_PAGES_NAMES.tit]: createPath(RECOMMENDATION_LETTERS_PAGES_NAMES.tit),
  [RECOMMENDATION_LETTERS_PAGES_NAMES.x5]: createPath(RECOMMENDATION_LETTERS_PAGES_NAMES.x5),
};
